import { connect } from "react-redux";
import { IntlProvider, IntlConfig } from "react-intl";

import { LocalisationState } from "../../models";
import { getLanguage, getMessages } from "../../selectors";

// Map the state to the component.
function mapStateToProps(state: LocalisationState): IntlConfig {
    return {
        locale: getLanguage(state),
        key: getLanguage(state),
        messages: getMessages(state),
    } as IntlConfig;
}

export const ConnectedIntlProvider =
    connect<IntlConfig, {}, Partial<IntlConfig>, {}>(mapStateToProps, null)(IntlProvider);
